import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 36475 36475"
    {...props}
  >
    <path
      d="M36473 18238c-17768 64-17781 126-1433 7098-16395-6861-16429-6810-3908 5796-12606-12522-12656-12487-5796 3908-6972-16348-7034-16335-7098 1433-65-17768-126-17781-7098-1433 6860-16395 6809-16429-5797-3908 12522-12606 12488-12657-3908-5796 16348-6972 16335-7034-1433-7098 17768-65 17781-126 1433-7098 16395 6860 16429 6809 3908-5797 12606 12522 12657 12488 5797-3908 6972 16348 7033 16335 7098-1433 64 17768 126 17781 7098 1433-6860 16395-6810 16429 5796 3908-12522 12606-12487 12657 3908 5797-16348 6972-16335 7033 1433 7098z"
      style={{
        fill: "#1c1b17",
        stroke: "#1c1b17",
        strokeWidth: 1072.68,
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
